import { authAxiosClient } from '@/lib';
import { withLogger } from '@/utils';

import { settingsAPIUrls } from '../data';

type Param = {
  firstName: string;
  lastName: string;
  email: string;
  twoFactorEnabled: boolean;
};

type Return = boolean;

export const updateUserProfile = withLogger(
  async (props: Param): Promise<Return> => {
    const url = `${settingsAPIUrls.update}`;

    await authAxiosClient.patch(url, props);

    return true;
  },
);
